import { ARAM_CONFIG } from '../../domain/map/aramRules.js';

/**
 * placeChampionOnMapSpawn — Snap entity to its team fountain / buy pad (ARAM).
 */
export function placeChampionOnMapSpawn(entity, mapId) {
  if (!entity || mapId !== 'aram_proving_grounds') return;
  const pad = ARAM_CONFIG.spawnPlatforms[entity.team] || ARAM_CONFIG.spawnPlatforms.blue;
  entity.x = pad.x;
  entity.z = pad.z;
  entity.targetX = pad.x;
  entity.targetZ = pad.z;
}

/** Seats every champion on its team buy pad at ARAM lock-in. */
export function placeChampionsOnMapSpawn(entities, mapId) {
  (entities || []).forEach((entity) => placeChampionOnMapSpawn(entity, mapId));
}
